<template>
  <div id="content">
    <preview-popup
        :preview-data="previewData"
        :show-preview="preview"
        @hide-preview="hidePreview"
    />
    <form>
      <div class="inner">
        <p class="paging">
          <router-link
              :to="{ name: moduleName }"
              class="btn btn_back"
              v-translate>Seznam
          </router-link>
        </p>
        <p class="buttons">
          <a class="btn btn_action btn_grey btn_preview"
             :title="'Náhled' | translate"
             @click.stop="showPreview"
             v-translate>Náhled</a>
        </p>
        <h1 v-translate>Nová šablona oznámení</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section v-show="$_createActionAllowedAllOrOwnAndGlobal">
            <div class="left">
              <h2 v-translate>Výběr typu šablony</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <p class="field">
                  <filter-checkbox
                      id="templateIsGlobal"
                      name="templateIsGlobal"
                      :val="isGlobal"
                      v-model="isGlobalComputed"
                  >
                    <translate class="translate">Globální šablona</translate>
                  </filter-checkbox>
                </p>
              </div>
              <div class="field_right" v-show="!isGlobalComputed">
                <select-box
                    id="operator"
                    v-model="operatorIdComputed"
                    :options="operatorOptions"
                >
                  <translate>Operátor</translate>
                </select-box>
              </div>
            </div>
          </section>
          <message-template-basic-info
              :entity="entity"
              :shouldLoadDefaultLanguage="true"
              ref="messagetemplatebasicref"
          />
          <form-buttons
              :module-name="moduleName"
              :custom-submit-text="'Uložit šablonu' | translate"
              @submit-form="submitForm"
          ></form-buttons>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import MessageTemplateBasicInfo from "./settings/MessageTemplateBasicInfo"
import messageTemplates from "./mixins/messageTemplates"
import FormButtons from "@/components/common/FormButtons"
import detailActions from "@/components/mixins/detail-actions"
import PreviewPopup from "../messages/popup/PreviewPopup.vue";

export default {
  name: "MessageTemplateNew",
  components: { PreviewPopup, FormButtons, MessageTemplateBasicInfo},
  mixins: [detailActions, messageTemplates],
  created: function (MessageTemplateService, OperatorService) {
    this.entityService = MessageTemplateService
    this.operatorService = OperatorService
    this.getOperatorsAndSetIdOperatorToEntity()
  },
  data: function () {
    return {
      preview: false,
      previewData: {},
    }
  },
  methods: {
    submitForm(redirect = false) {
      this.$refs.messagetemplatebasicref.saveCurrentTranslation()
      this.createEntity(redirect)
    },
    redirect() {
      this.$router.push({name: 'messageTemplates'})
    },
    showPreview() {
      this.previewData = this.$refs.messagetemplatebasicref.saveCurrentTranslation()
      this.preview = true
    },
    hidePreview() {
      this.preview = false
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/messagetemplates/MessageTemplateNew.vue